import tailwindColors from "tailwindcss/colors.js";
import type { EnumType } from "../enums/EnumType";

const TAILWIND_COLORS = {
  green600: tailwindColors.green["600"],
  orange600: tailwindColors.orange["600"],
  purple600: tailwindColors.purple["600"],
  red600: tailwindColors.red["600"],
  sky600: tailwindColors.sky["600"],
  slate50: tailwindColors.slate["50"],
  slate100: tailwindColors.slate["100"],
  slate200: tailwindColors.slate["200"],
  slate300: tailwindColors.slate["300"],
  slate400: tailwindColors.slate["400"],
  slate500: tailwindColors.slate["500"],
  slate600: tailwindColors.slate["600"],
  slate800: tailwindColors.slate["800"],
  slate900: tailwindColors.slate["900"],
  white: "#ffffff",
  yellow500: tailwindColors.yellow["500"],
};

const COLORS = {
  ...TAILWIND_COLORS,
  brand: "#D72D87",
  secondary: TAILWIND_COLORS.sky600,
  positive: TAILWIND_COLORS.green600,
  error: TAILWIND_COLORS.red600,
  warning: TAILWIND_COLORS.yellow500,
};

type COLORS = EnumType<typeof COLORS>;

export default COLORS;
